import { render, staticRenderFns } from "./jlparams.vue?vue&type=template&id=2f85a8a8&scoped=true&"
import script from "./jlparams.vue?vue&type=script&lang=js&"
export * from "./jlparams.vue?vue&type=script&lang=js&"
import style0 from "./jlparams.vue?vue&type=style&index=0&id=2f85a8a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f85a8a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f85a8a8')) {
      api.createRecord('2f85a8a8', component.options)
    } else {
      api.reload('2f85a8a8', component.options)
    }
    module.hot.accept("./jlparams.vue?vue&type=template&id=2f85a8a8&scoped=true&", function () {
      api.rerender('2f85a8a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/jlparams.vue"
export default component.exports